


import React, { useEffect, useState, useMemo } from "react";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const Eventsubscribedclients = () => {
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const { showLoader, hideLoader } = useLoader();
    const [error, setError] = useState(null);
    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    const formatShortDate = (isoString) =>
        new Date(isoString)
            .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "2-digit",
            })
            .replaceAll("/", "-");
    useEffect(() => {
        const token = localStorage.getItem("authToken");

        if (!token) {
            console.warn("⚠️ No authToken found.");
            return;
        }

        showLoader();

        fetch(
            "https://backend.maamaas.com/subscription/api/admin/vendor_subscription/get-all",
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                    Accept: "*/*",
                },
            }
        )
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            })

            .then((subs) => {
                const mapped = subs
                    .filter(
                        (s) =>
                            s.subscriptionPlan?.businessVerticals ===
                            "FOOD_AND_BEVERAGES"
                    )
                    .map((s, idx) => ({
                        id: s.id ?? idx,
                        vendorName: s.vendorEnquiry?.name,
                        vendorId: s.vendorEnquiry?.vendorId,
                        email: s.vendorEnquiry?.email,
                        mobileNumber: s.vendorEnquiry?.mobileNumber,
                        businessVertical: s.subscriptionPlan?.businessVerticals,
                        plan: s.subscriptionPlan?.planType,
                        startDate: s.startDate,
                        endDate: s.endDate,
                        active: s.active,
                        status: s.status,
                    }));

                setData(mapped);
            })

            .catch((err) => {
                console.error("Error:", err);
                setError(err.message);
            })

            .finally(() => {
                hideLoader();
            });
    }, []);



    const filteredData = useMemo(() => {
        return data.filter(user => {
            const statusMatch =
                !selectedStatusFilter ||
                (user.statusAsDeliveryAgent &&
                    user.statusAsDeliveryAgent.toLowerCase() === selectedStatusFilter.toLowerCase());
            return statusMatch;
        });
    }, [data, selectedStatusFilter]);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12" style={{ marginTop: "0px" }}>
                    <div
                        className="user-management-page"
                        style={{
                            overflowY: "auto",
                            height: "70vh",
                            scrollbarWidth: "thin",
                            marginTop: "15px",
                        }}
                    >
                        <div className="user-management-container" style={{ marginLeft: "0px" }}>



                            <div className="user-table-wrapper">
                                <table style={{ width: "100%", fontSize: "0.95rem", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr>
                                            <th style={tableHeaderStyle}>SNO</th>
                                            <th style={tableHeaderStyle}>VendorName</th>
                                            <th style={tableHeaderStyle}>VendorID</th>
                                            <th style={tableHeaderStyle}>Email</th>
                                            <th style={tableHeaderStyle}>Phone</th>
                                            <th style={tableHeaderStyle}>Vertical</th>
                                            <th style={tableHeaderStyle}>Plan</th>
                                            <th style={tableHeaderStyle}>StartDate</th>
                                            <th style={tableHeaderStyle}>End Date</th>
                                            <th style={tableHeaderStyle}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length === 0 ? (
                                            <tr>
                                                <td colSpan="10" style={tableCellStyle}>
                                                    {error
                                                        ? `⚠️ ${error}`
                                                        : "Loading…"}
                                                </td>
                                            </tr>
                                        ) : (
                                            data.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td style={tableCellStyle}>
                                                        {index + 1}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.vendorName}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.vendorId}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.email}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.mobileNumber}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.businessVertical}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.plan}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {formatShortDate(item.startDate)}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {formatShortDate(item.endDate)}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.status}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Styles
const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
    padding: "6px",
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "6px",
};

const noDataStyle = {
    fontStyle: "italic",
    textAlign: "center",
    padding: "10px",
    color: "#888",
};

export default Eventsubscribedclients;
